import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EMPTY, Subject, iif } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { AuthorizeService } from 'src/app/_core/access-control/authorize.service';
import { ContactTableComponent } from 'src/app/_shared/component/contact-table/contact-table.component';
import { PaginatedBackendResponse } from 'src/app/_shared/interface/common.interface';
import { MultiSelectOption } from 'src/app/_shared/interface/multi-select.interface';
import { CampaignService } from 'src/app/_shared/service/campaign.service';
import { CampaignState } from 'src/app/_shared/state/campaign.state';
import { ContactState } from 'src/app/_shared/state/contact.state';
import { SubscriptionState } from 'src/app/_shared/state/subscription.state';
import { UserState } from 'src/app/_shared/state/user.state';
import { AppState } from 'src/app/app.state';
import { ClientDashboardService } from 'src/app/client-dashboard/service/client-dashboard.service';
import { ClientDashboardState } from 'src/app/client-dashboard/state/client-dashboard.state';
import { default as constant, default as constants } from 'src/constant.json';
import { SelectSearchDropdownComponent } from '../../../client-dashboard/component/select-search-dropdown/select-search-dropdown.component';
import { CampaignAutomationDialogComponent } from '../campaign-automation-dialog/campaign-automation-dialog.component';

@Component({
  providers: [SelectSearchDropdownComponent],
  selector: 'app-create-campaign-sheet',
  templateUrl: './create-campaign-sheet.component.html',
  styleUrls: ['./create-campaign-sheet.component.scss'],
})
export class CreateCampaignSheetComponent implements OnInit, OnDestroy {
  @ViewChild(ContactTableComponent, { static: false }) contactTable: ContactTableComponent;
  @Output() isCloseCampaignInfo = new EventEmitter<any>();
  campaignCreationInProgress: boolean;
  campaignForm: FormGroup;
  campaignType = {};
  constant: any = constants;
  csvFileColumns: string[] = ['name', 'validEmailCount', 'validAddressCount'];
  csvRecordColumns: string[] = ['select', 'firstName', 'email', 'address'];
  editCampaign: any;
  filter: string;
  filterApplied: string;
  isLaunchCampaignSelected: boolean = false;
  isLoading: boolean = false;
  partnerList = [];
  selectedCampaignType: string;
  selectedContactIdList: Array<string> = [];
  editSelectedInfo = [];
  selectedContacts = [];
  selectedIdList = [];
  selectedPartner: string = null;
  selectedRecordCount = 0;
  subscriptionPlanDetails;
  userType: string;
  multiSelectOptionsForAgents: MultiSelectOption[] = [];
  multiSelectOptionsForLoanOfficer: MultiSelectOption[] = [];
  clearSearch = 'hide';
  hasMoreAgents: boolean = true;
  hasMoreLoanOfficers: boolean = true;
  selectedAgent: Array<string>;
  selectedLoanOfficer: Array<string>;
  agentUserFetchParams = { userType: 'agent', limit: 20, offset: 0, searchQuery: null };
  loanOfficerUserFetchParams = { userType: 'loanOfficer', limit: 20, offset: 0, searchQuery: null };
  campaignError: string;
  onDestroyNotifier$ = new Subject();
  campaignList: any;
  isLaunchAll: any;
  defaultCampaignType: any;
  contactGroupId: any;
  selectedRecordsCampaignId: any;
  isLaunchAllSelected: any;
  isLaunchNow: boolean = false;
  selectedCampaignInfo: any;
  campaignMode: any;

  constructor(
    public appState: AppState,
    private campaignService: CampaignService,
    private clientDashboardState: ClientDashboardState,
    private formBuilder: FormBuilder,
    private matDialog: MatDialog,
    private snackBar: MatSnackBar,
    private subscriptionState: SubscriptionState,
    public campaignState: CampaignState,
    private clientDashboardService: ClientDashboardService,
    public authorizeService: AuthorizeService,
    public userState: UserState,
    private contactState: ContactState
  ) { }

  ngOnInit() {
    this.campaignList = this.appState.companyInfoValue.campaign;

    if (this.appState?.appCompanyAliasValue == 'valuetest') {
      this.userState.userPlanStatus.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res: any) => {
        if (res) {
          if (
            !res.featureList?.pastClientEngage?.enabled &&
            !this.userState.userDetails?.roles?.includes('companyEmployee') &&
            !this.userState.userDetails?.roles?.includes('companyManager')
          ) {
            this.campaignList = this.campaignList.filter((item) => item.value != 'CAMP_MY_HOME');
          }
        }
      });
    }

    this.listenToUserDetails();
    this.campaignForm = this.formBuilder.group({
      campaignId: [],
      campaignName: [null, Validators.required],
      campaignType: [
        this.defaultCampaignType ? this.defaultCampaignType : this.campaignList[0].value,
        Validators.required,
      ],
      contactIdList: [this.selectedContactIdList],
      launchCampaign: [false],
      agent: [''],
      loanOfficer: [''],
    });

    this.filter = this.defaultCampaignType ? this.defaultCampaignType : this.campaignList[0].value;
    this.filterApplied = this.defaultCampaignType ? this.defaultCampaignType : this.campaignList[0].value;
    this.campaignState.campaignToEdit$
      .pipe(
        switchMap((campaign: any) => {
          this.campaignMode = campaign?.mode;
          this.campaignForm.controls.campaignId.setValue(campaign?._id);
          if (campaign) {
            this.campaignForm.controls.campaignName.setValue(campaign.campaignName);
            this.campaignForm.controls.campaignType.setValue(campaign.type);
            this.selectedCampaignInfo = campaign;
            if (campaign?.mode == 'addContact') {
              this.campaignForm.get('campaignName')?.disable();
              this.campaignForm.get('campaignType')?.disable();
              this.campaignForm.controls.contactIdList.setValue([]);
              let campaignId = campaign._id;
              return this.campaignService.getCampaignCandidates(campaignId);
              //  this.campaignForm.controls.contactIdList.setValue(this.selectedContactIdList);
              // return EMPTY;
            }
            if (campaign?.mode == 'isAutomatedCampaign') {
              this.campaignForm.controls.campaignType.setValue(campaign._id);
              ['campaignName', 'agent', 'loanOfficer'].forEach((field) => {
                if (this.campaignForm.contains(field)) {
                  this.campaignForm.removeControl(field);
                }
              });
            }
            //    campaign.campaignId = '6877878844d7c8346fcd2442';
          }
          this.filterApplied = campaign?.type;

          return EMPTY;
        }),
        takeUntil(this.onDestroyNotifier$)
      )
      .subscribe(({ isLoading, data }) => {
        this.isLoading = isLoading;
        if (data && data.length) {
          this.selectedContactIdList = [];
          data.forEach((candidate) => {
            candidate['id'] = candidate.contactIdList[0];
            // if (this.selectedCampaignInfo?.mode == 'addContact') {
            //   this.editSelectedInfo = null;
            // } else {
            this.editSelectedInfo = this.editSelectedInfo.concat(candidate);
            // }
            this.selectedContactIdList = this.selectedContactIdList.concat(candidate.contactIdList);
          });
          this.campaignForm.controls.contactIdList.setValue(this.selectedContactIdList);
          if (this.selectedCampaignInfo?.mode == 'addContact') {
            this.campaignForm.controls.contactIdList.setValue([]);
          }
        }
      });

    this.clientDashboardState.agentList$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((usersList: PaginatedBackendResponse) => {
        if (this.agentUserFetchParams.offset == 0) this.multiSelectOptionsForAgents = [];
        this.multiSelectOptionsForAgents = JSON.parse(
          JSON.stringify(
            usersList?.data?.reduce((filtered, client) => {
              if (client.userType == 'agent')
                filtered.push({
                  displayText: `${client.firstName} ${client.lastName}`,
                  value: client._id,
                } as MultiSelectOption);
              return filtered;
            }, this.multiSelectOptionsForAgents) || []
          )
        );
        if (usersList?.data?.length != 0 && usersList?.data?.length == usersList?.totalCount) {
          this.hasMoreAgents = false;
        }
        if (usersList?.data?.length) {
          this.agentUserFetchParams.offset += 20;
        }
      });

    this.clientDashboardState.loanOfficerList$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((loanOfficerList: PaginatedBackendResponse) => {
        if (this.loanOfficerUserFetchParams.offset == 0 || this.appState?.appCompanyAliasValue == 'valuetest')
          this.multiSelectOptionsForLoanOfficer = [];
        this.multiSelectOptionsForLoanOfficer = JSON.parse(
          JSON.stringify(
            loanOfficerList?.data?.reduce((filtered, client) => {
              if (client.userType == 'loanOfficer')
                filtered.push({
                  displayText: `${client.firstName} ${client.lastName}`,
                  value: client._id,
                } as MultiSelectOption);
              return filtered;
            }, this.multiSelectOptionsForLoanOfficer) || []
          )
        );
        if (loanOfficerList?.data?.length != 0 && loanOfficerList?.data?.length == loanOfficerList?.totalCount) {
          this.hasMoreLoanOfficers = false;
        }
        if (loanOfficerList?.data?.length) this.loanOfficerUserFetchParams.offset += 20;
      });

    this.campaignForm?.controls?.contactIdList.valueChanges
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((contactIdList) => { });

    this.campaignForm?.controls?.campaignType.valueChanges
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((type) => {
        if (type) {
          const findCampaign = this.campaignList.find((campaign) => campaign.value === type);
          if (findCampaign && findCampaign.contactType) {
            this.filter = findCampaign.contactType;
            this.filterApplied = findCampaign.value;
          }
        }
        if (this.userState.userDetails?.roles?.includes('loanOfficer')) {
          if (type == constants.CAMPAIGN_TYPE.myHome) {
            this.campaignForm.controls.agent.clearValidators();
          }
          if (type == constants.CAMPAIGN_TYPE.investorInvitation) {
            this.campaignForm.controls.agent.setValidators(Validators.required);
          }
          this.campaignForm.controls.agent?.updateValueAndValidity();
        }
      });
  }

  updateSelectedOptions($event: Array<MultiSelectOption>, role) {
    if (role == 'agent') {
      if (!$event?.length || $event?.length == this.multiSelectOptionsForAgents.length) {
        this.campaignForm.controls.agent.patchValue($event);
        return (this.selectedAgent = null);
      }
      this.selectedAgent = $event?.map((option) => option.value)[0];
    }

    if (role == 'loanOfficer') {
      // Don't understand the logic behind this so commenting the code for valuetest
      if (
        (!$event?.length || $event?.length == this.multiSelectOptionsForLoanOfficer.length) &&
        this.appState?.appCompanyAliasValue != 'valuetest'
      ) {
        this.campaignForm.controls.loanOfficer.patchValue($event);
        return (this.selectedLoanOfficer = null);
      }
      this.selectedLoanOfficer = $event?.map((option) => option.value)[0];
    }
  }

  fetchNextAgentUserList() {
    this.clientDashboardService
      .fetchAgents(this.agentUserFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res?.data && !res.data?.data?.length) this.hasMoreAgents = false;
      });
  }

  fetchNextLoanOfficerUserList() {
    this.clientDashboardService
      .fetchLoanOfficers(this.loanOfficerUserFetchParams)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res?.data && !res.data?.data?.length) this.hasMoreLoanOfficers = false;
      });
  }

  searchAgentUser(searchText: string) {
    this.hasMoreAgents = true;
    this.agentUserFetchParams.offset = 0;
    this.agentUserFetchParams.searchQuery = searchText;
    this.fetchNextAgentUserList();
  }

  searchLoanOfficerUser(searchText: string) {
    this.hasMoreLoanOfficers = true;
    this.loanOfficerUserFetchParams.offset = 0;
    this.loanOfficerUserFetchParams.searchQuery = searchText;
    this.fetchNextLoanOfficerUserList();
  }

  createCampaign(): void {

    this.contactState.contactListValue = null;
    this.campaignForm.markAllAsTouched();
    this.campaignError = '';
    const contactList = this.campaignForm?.controls?.contactIdList?.value;

    if (!this.campaignForm.valid) return;
    if (!contactList || !Array.isArray(contactList) || contactList.length === 0) {
      this.openSnackbar('Please select atleast one contact', 'snackbar-error');
      return;
    }
    if (this.selectedCampaignInfo?.mode == 'isAutomatedCampaign') {
      const automatedCampaign = {
        contactIdList: this.campaignForm.controls.contactIdList.value,
        type: this.selectedCampaignInfo._id,
        //   campaignTrue: this.selectedRecordsCampaignId ? true : false,
      };
      this.createAutomatedCampaign(automatedCampaign);
      return;
    } else {
      const campaign = {
        name: this.campaignForm.controls.campaignName.value,
        type: this.campaignForm.controls.campaignType.value,
        contactIdList: this.campaignForm.controls.contactIdList.value,
        agentId: this.selectedAgent,
        loanOfficerId: this.selectedLoanOfficer,
        launchAll: this.isLaunchAll ? this.isLaunchAll : true,
        campaignId: this.selectedRecordsCampaignId,
        campaignTrue: this.selectedRecordsCampaignId ? true : false,
      };

      //}

      if (this.selectedCampaignInfo?.mode === 'addContact') {
        this.isLoading = true;
        campaign.contactIdList = Array.from(
          new Set([...(campaign.contactIdList || []), ...(this.selectedContactIdList || [])])
        );
        this.campaignService
          .updateCampaign(this.campaignForm.controls.campaignId.value, campaign)
          .pipe(takeUntil(this.onDestroyNotifier$))
          .subscribe(({ isLoading, data }) => {
            if (data) {
              this.campaignService
                .launchCampaign(data, 'one_time', true)
                .pipe(takeUntil(this.onDestroyNotifier$))
                .subscribe();
            }
            this.isLoading = isLoading;
            if (isLoading === false) {
              this.closeSheet();
            }
          });
      } else {
        let campList = [
          constant.CAMPAIGN_TYPE.cashOutRefinanceCamp,
          constant.CAMPAIGN_TYPE.valueUpdateCamp,
          constant.CAMPAIGN_TYPE.marketValueCamp,
          constant.CAMPAIGN_TYPE.myHome,
        ];
        if (campList.includes(campaign.type) || this.appState?.appCompanyAliasValue == 'valuetest') {
          this.campaignState.selectedCampValue = campaign.type;
          const campaignAutomationDialogRef = this.matDialog.open(CampaignAutomationDialogComponent);
          campaignAutomationDialogRef
            .afterClosed()
            .pipe(takeUntil(this.onDestroyNotifier$))
            .subscribe((frequency) => {
              if (!frequency) return;
              this.isLoading = true;
              iif(
                () => this.campaignForm.controls.campaignId.value,
                this.campaignService.updateCampaign(this.campaignForm.controls.campaignId.value, campaign),
                this.campaignService.createCampaign(campaign)
              )
                .pipe(takeUntil(this.onDestroyNotifier$))
                .subscribe(({ isLoading, data }) => {
                  if (data) {
                    this.campaignService
                      .launchCampaign(data, frequency, this.isLaunchNow)
                      .pipe(takeUntil(this.onDestroyNotifier$))
                      .subscribe();
                  }
                  this.isLoading = isLoading;
                  if (isLoading === false) {
                    this.isCloseCampaignInfo.emit(false);
                    this.closeSheet();
                  }
                });
            });
        } else {
          this.isLoading = true;
          iif(
            () => this.campaignForm.controls.campaignId.value,
            this.campaignService.updateCampaign(this.campaignForm.controls.campaignId.value, campaign),
            this.campaignService.createCampaign(campaign)
          )
            .pipe(takeUntil(this.onDestroyNotifier$))
            .subscribe(({ isLoading, data }) => {
              if (this.campaignForm.controls.launchCampaign.value && data) {
                this.campaignService
                  .launchCampaign(data, 'one_time', this.isLaunchNow)
                  .pipe(takeUntil(this.onDestroyNotifier$))
                  .subscribe();
              }
              this.isLoading = isLoading;
              if (isLoading === false) {
                this.closeSheet();
                this.isCloseCampaignInfo.emit(false);

              }
            });
        }
      }
    }
    this.campaignService.fetchCampaigns({ page: 0, limit: 10 });
  }

  createAutomatedCampaign(params) {
    this.campaignService
      .launchAutomatedCampaign(params, true)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(({ isLoading, data }) => {
        this.isLoading = isLoading;
        if (isLoading === false) {
          this.closeSheet();
        }
      });
  }

  launchNow() {
    this.isLaunchNow = !this.isLaunchNow;
  }

  onCampaignSelection(event?) {
    if (
      (event &&
        event.value &&
        (event.value === constants.CAMPAIGN_TYPE.agentInvestorInvite ||
          event.value === constants.CAMPAIGN_TYPE.lenderInvestorInvite)) ||
      (!event &&
        this.selectedCampaignType &&
        (this.selectedCampaignType === constants.CAMPAIGN_TYPE.agentInvestorInvite ||
          this.selectedCampaignType === constants.CAMPAIGN_TYPE.lenderInvestorInvite))
    ) {
      this.csvRecordColumns = ['select', 'firstName', 'lastName', 'email', 'invitationStatus'];
    }
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
    this.contactState.selectedContactsListValue = null;
  }

  closeSheet() {
    this.contactState.contactListValue = null;
    this.campaignState.openCreateCampaignSheetValue = false;
    this.campaignState.campaignToEditValue = null;
    this.campaignForm.reset();
    this.onDestroyNotifier$?.next();
    this.onDestroyNotifier$?.complete();
  }

  selectedRecords(records) {
    this.campaignForm.controls.contactIdList.setValue(records);
    this.campaignError = '';
  }

  openSnackbar(message, style) {
    this.snackBar.open(message, '', {
      duration: 3000,
      panelClass: [style],
      verticalPosition: 'top',
    });
  }

  getSubscriptionPlan() {
    this.subscriptionState.planUsage.pipe(takeUntil(this.onDestroyNotifier$)).subscribe(
      (res) => {
        this.subscriptionPlanDetails = res;
      },
      (err) => {
        console.log('err:', err);
      }
    );
  }

  listenToUserDetails(): void {
    this.userState.userDetail$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      this.userType =
        (res?.roles?.includes('agent') && 'agent') ||
        (res?.roles?.includes('loanOfficer') && 'loanOfficer') ||
        (res?.roles?.includes('companyManager') && 'companyManager');
    });
  }

  get campaignFormCtrlList() {
    return this.campaignForm.controls;
  }
}
